export default {
  customerInfos: {
    get () {
      return this.current_step_name === undefined || this.current_step_name === 'customer'
        ? this.customer_infos
        : this.contractor_infos
    },
    set (newCustomer) {
      this.current_step_name === undefined || this.current_step_name === 'customer'
        ? this.customer_infos = this.objectCopy(newCustomer)
        : this.contractor_infos = this.objectCopy(newCustomer)
    }
  },

  /* To know if we show the reset button */
  checkFilledCustomer () {
    const entityInfos = this.customerInfos
    return entityInfos.gender || entityInfos.last_name || entityInfos.first_name || entityInfos.birthdate || entityInfos.email || entityInfos.mobile_phone_number || entityInfos.phone_number || entityInfos.company_name || entityInfos.company_siren || entityInfos.address || entityInfos.postal_code || entityInfos.country_code || entityInfos.city
  },

  customerFullName () {
    return this.customerFullNameByEntity()
  },

  contractorFullName () {
    return this.customerFullNameByEntity('contractor')
  },

  customerAddressReformed () {
    return this.addressReformedByEntity()
  },

  contractorAddressReformed () {
    return this.addressReformedByEntity('contractor')
  },

  availableCountriesMapped () {
    return window.availableCountries.reduce((acc, availableCountry) => {
      return {
        ...acc,
        [availableCountry.code]: availableCountry.name
      }
    }, {})
  },

  dateMaxBirthday () {
    return window.moment()
      .startOf('day')
      .subtract(18, 'years')
      .format('YYYY-MM-DD')
  },

  parseSiren: {
    get () {
      return this.customerInfos.company_siren
        ? [...this.customerInfos.company_siren].filter(char => !/\s/.test(char))
          .map((number, index) => index % 3 ? number : ' ' + number)
          .join('')
          .trim()
        : ''
    },
    set (newSiren) {
      if (newSiren) {
        const newSirenWithoutSpaces = [...newSiren].filter(char => !/\s/.test(char))
          .join('')
          .trim()
        if (newSirenWithoutSpaces.length <= 9) this.customerInfos.company_siren = newSirenWithoutSpaces
      } else this.customerInfos.company_siren = null
    }
  },

  customerCitiesDatalist () {
    if (this.cities === null) return []

    const citiesDatalist = this.cities.filter(city => city.postal_code === this.customerInfos.postal_code)

    /* If only one city for this postal code => load countries */
    if (this.customerInfos.city === '' && citiesDatalist.length === 1) this.customerInfos.city = citiesDatalist[0].name

    if (citiesDatalist.length > 1 && this.$refs.customer_city_name !== undefined) this.$refs.customer_city_name.$el.focus()

    if ((this.current_step_name === undefined || this.current_step_name === 'customer') && this.customerInfos.postal_code !== '' && this.customerInfos.city !== '') {
      /* Get the city with city name && postal_code */
      const city = citiesDatalist
        .filter(city => city.name === this.customerInfos.city && city.postal_code === this.customerInfos.postal_code)

      /* If the correspondence exist set the new country code */
      if (city[0]) this.customerInfos.country_code = city[0].country_code
    }

    return citiesDatalist
  }
}
